import React from "react";
import { Field } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import { Checkbox } from "components/Form/SpecialButtons";

const GeneralForm = ({ element }) => (
	<div>
		<Field type="text" name="name" customlabel="Nom (enumName dans GesLab)" component={CustomInputTextComponent} required />
		<Field type="text" name="title" customlabel="Titre (enumTitle dans GesLab)" component={CustomInputTextComponent} required />
		<Field type="number" name="order" customlabel="Ordre d'apparition" component={CustomInputTextComponent} required />
		<Field name="is_visible" id="is_visible" customlabel="Afficher" component={Checkbox} required />
		<Field
			name="is_prescription_default"
			id="is_prescription_default"
			customlabel="Valeur par défault pour les documents d'une prescription"
			component={Checkbox}
			required
		/>
	</div>
);

export default GeneralForm;
